// extracted by mini-css-extract-plugin
export default {"container":"container__Q4CkX","widgetQuestion":"widgetQuestion__nGYlW"};